import { fileConstants } from '../constants';

const initialState: { filename: string; file: any }[] = [];
export const uploadingFiles = (
  state = initialState,
  action: {
    type: string;
    payload: {
      newNames?: string[];
      newName?: string;
      error?: string;
      index?: number;
      indexes?: number[];
    };
  },
) => {
  switch (action.type) {
    case fileConstants.FILE_UPLOAD_REQUEST:
      return [
        ...state,
        {
          filename: action.payload.newName,
          status: 'REQUESTING',
        },
      ];
    case fileConstants.FILE_UPLOAD_SUCCESS:
      if (!action.payload.newNames) {
        return state;
      }
      return state.filter(
        (s) =>
          !(action.payload.newNames as string[]).includes(s.filename),
      );
    case fileConstants.FILE_UPLOAD_ERROR:
      return state.map((s) =>
        s.filename !== action.payload.newName
          ? s
          : { ...s, status: 'ERROR', error: action.payload.error },
      );
    case fileConstants.FILE_DELETE_LOCAL_AT_INDEX:
      return state.filter((s, i) => i !== action.payload.index);
    case fileConstants.FILE_DELETE_LOCAL_AT_INDEXES:
      if (!action.payload.indexes) {
        return state;
      }
      return state.filter(
        (s, i) => !(action.payload.indexes as number[]).includes(i),
      );
    default:
      return state;
  }
};
